import React from "react";
import C from "../constants/colors";
import { fmtCurrency } from "../utils/format";
import { getPricePerSqm, getTotalArea } from "../utils/unitCalculations";

const SpecRow = ({ label, value }) => (
  <div className="ud-spec-row">
    <span style={{ fontSize: "0.625rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", color: C.muted }}>
      {label}
    </span>
    <span style={{ fontSize: "0.8125rem", fontWeight: 600, color: C.primary }}>
      {value || "—"}
    </span>
  </div>
);

const TechnicalSpecs = ({ data, currency, sold }) => {
  const { unit } = data || {};

  return (
    <div className="ud-section-card h-100">
      <div className="ud-section-card-header">
        <span style={{ fontWeight: 700, color: C.primary, fontSize: "0.9375rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <i className="ri-settings-3-line" /> Technical Specs
        </span>
      </div>
      <div style={{ padding: "1.5rem 1.75rem" }}>
        <SpecRow label="Unit Type" value={unit?.unit_type} />
        <SpecRow label="Apartment" value={unit?.apt_type} />
        <SpecRow label="Floor / Level" value={unit?.floor} />
        <SpecRow label="Rooms" value={unit?.num_rooms} />
        <SpecRow label="Net Area" value={unit?.net_sqm ? `${unit.net_sqm} m²` : null} />
        <SpecRow label="Terrace" value={unit?.terrace_net_sqm ? `${unit.terrace_net_sqm} m²` : null} />
        <SpecRow label="Total Area" value={`${getTotalArea(data)} m²`} />
        <SpecRow label="CF" value={unit?.cf} />
        {sold && (
          <SpecRow
            label="Price / m²"
            value={getPricePerSqm(data) ? `${fmtCurrency(getPricePerSqm(data), currency)}/m²` : null}
          />
        )}
      </div>
    </div>
  );
};

export default TechnicalSpecs;
